/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1598
 */

var r = require(/* 86 */"../1650/86/index")
var o = require(/* 1244 */"../1751/1244")
var i = require(/* 637 */"./637")
r({
  target: "Array",
  proto: true
}, {
  copyWithin: o
})
i("copyWithin")
